(function () {
  initializeUtilsFunctions();
  executeOnce('compare-page', function () {
    function openModalFormLead() {
      const btns = document.querySelectorAll('.btn-ask-info');

      if (btns && btns.length > 0) {
        btns.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            const modal = document.querySelector('.modal-form-lead');
            //set attribute to modal lead
            const carIndex = e.currentTarget.getAttribute('data-compare-index');
            let carData;

            // MK default

            window.masterKeyFull.campaign_ID = mk_default.campaign_ID;
            window.masterKeyFull.offer_ID = mk_default.offer_ID;
            window.masterKeyFull.campaign_descr = mk_default.campaign_descr;
            window.masterKeyFull.offer_descry = mk_default.offer_descry;

            if (carIndex === '1') {
              carData = analyticsCompare1;

              //MK Override car1
              if (typeof mk_car1 !== 'undefined') {
                window.masterKeyFull.campaign_ID = mk_car1.campaign_ID;
                window.masterKeyFull.offer_ID = mk_car1.offer_ID;
                window.masterKeyFull.campaign_descr = mk_car1.campaign_descr;
                window.masterKeyFull.offer_descry = mk_car1.offer_descry;
              }
            } else {
              carData = analyticsCompare2;

              // MK Overrire car2
              if (typeof mk_car2 !== 'undefined') {
                window.masterKeyFull.campaign_ID = mk_car2.campaign_ID;
                window.masterKeyFull.offer_ID = mk_car2.offer_ID;
                window.masterKeyFull.campaign_descr = mk_car2.campaign_descr;
                window.masterKeyFull.offer_descry = mk_car2.offer_descry;
              }
            }

            const info = e.currentTarget.parentNode.querySelector(
              '.data-variation',
            )
              ? e.currentTarget.parentNode.querySelector('.data-variation')
              : e.currentTarget.parentNode.parentNode.querySelector(
                  '.data-variation',
                );
            const form = document.querySelector(
              '#brandId-' +
                info.getAttribute('data-brand-id') +
                '-' +
                info.getAttribute('data-model-id') +
                '-' +
                info.getAttribute('data-variation-id') +
                ' .form-lead',
            );
            form.setAttribute(
              'data-model-id',
              info.getAttribute('data-model-id'),
            );
            form.setAttribute(
              'data-brand-id',
              info.getAttribute('data-brand-id'),
            );
            form.setAttribute(
              'data-motornet-id',
              info.getAttribute('data-motornet-id'),
            );
            form.setAttribute(
              'data-variation-id',
              info.getAttribute('data-variation-id'),
            );
            form.setAttribute(
              'data-form-active',
              info.getAttribute('data-form-active'),
            );

            form.setAttribute('data-variation-name', carData.variation);
            form.setAttribute('data-model-name', carData.model);
            form.setAttribute('data-brand-name', carData.brand);

            form.setAttribute('data-push', info.getAttribute('data-push'));
            form.setAttribute(
              'data-dealer-mandatory',
              info.getAttribute('data-dealer-mandatory'),
            );
            const car =
              e.currentTarget.parentNode
                .querySelector('.brand')
                .innerText.replace(/<[^>]*>?/gm, '') +
              ' ' +
              e.currentTarget.parentNode
                .querySelector('.model')
                .innerText.replace(/<[^>]*>?/gm, '');
            form
              .querySelector('.step-1')
              .querySelector('.model')
              .querySelector('.car').innerText = car.replace(/[\r\n]+/gm, '');
            const variation = sanitizeGetAttribute(
              e.currentTarget.getAttribute('data-variation-name'),
            )
              ? e.currentTarget.getAttribute('data-variation-name')
              : null;
            form
              .querySelector('.step-1')
              .querySelector('.car--container')
              .querySelector('.variation').innerText = variation;
            form.querySelectorAll('.form-field').forEach((item) => {
              item.classList.remove('active');
            });
            let priceString = form.querySelector('.compare-price').textContent;
            if (priceString.indexOf('.') < 5) {
              priceString = priceString.replace('.', '');
            }
            window.priceCriteo = parseFloat(priceString.replace(' €', ''));
            window.modelCriteo =
              form.querySelector('.compare-model').textContent;

            let modalContent = document.querySelector('.modal-form-lead');
            let formModal = document.querySelector(
              '.modal-form-lead + .form-lead',
            );
            if (formModal) {
              formModal.remove();
            }
            let cloneForm = form.cloneNode(true);
            modalContent.after(cloneForm);
            if (cloneForm) {
              cloneForm
                .querySelector('.icon-close-modal')
                .addEventListener('click', () => {
                  modal.click();
                });
            }
            if (info.getAttribute('data-form-active') === 'On') {
              inizializeFormLead(true);
              getPrivacyForm(true, '.modal-form-lead + .form-lead');
            } else {
              setTimeout(() => {
                modal.classList.toggle('active');
              }, 10);
            }
            if (modal) {
              modal.addEventListener('click', (e) => {
                modal.classList.remove('active');
                cloneForm.querySelector('.step-1').classList.add('active');
                cloneForm.querySelector('.step-2').classList.remove('active');
                cloneForm.querySelector('.step-3').classList.remove('active');
                cloneForm
                  .querySelector('.step-completed')
                  .classList.remove('active');
                cloneForm
                  .querySelector('.dealer-container')
                  .classList.remove('active');
                if (cloneForm.querySelector('.checkbox-container')) {
                  cloneForm
                    .querySelector('.checkbox-container')
                    .classList.remove('active');
                }
                cloneForm.querySelectorAll('input').forEach((i) => {
                  i.classList.remove('valid');
                  i.classList.remove('invalid');
                  i.value = null;
                  i.checked = false;
                });
              });
            }
          });
        });
      }
    }

    function cardAddToCompare() {
      const btns = document.querySelectorAll('.card-add-to-compare');
      if (btns && btns.length > 0) {
        btns.forEach((btn) => {
          btn.addEventListener('click', () => {
            const modalSelectCompare = document.querySelector(
              '.modal-select-compare-car',
            );
            if (
              modalSelectCompare &&
              modalSelectCompare.querySelectorAll(
                '.custom-select.initialized',
              ) &&
              !modalSelectCompare.querySelectorAll('.select-items > div').length
            ) {
              getBrands();
            }
            modalSelectCompare.classList.add('active');
            modalSelectCompare.classList.add('is-compare-page');
          });
        });
      }
    }

    function onVariationClick(variationName, index, variation) {
      const variationId = sanitizeGetAttribute(
        document
          .querySelector('.car-compare-' + index)
          .querySelector('.remove-car-button')
          .getAttribute('data-variation-id'),
      );
      variationName = variationName.replace(/ /g, '-');
      if (+variationId !== variation) {
        submitForm();
      }
    }

    function getMostEconomicVariation(idModel, idFuel, index) {
      const uri = '/api/content/most-economic/' + idModel + '/' + idFuel;
      callApi({
        uri: window.location.origin + sanitizeUri(uri),
        method: 'GET',
      })
        .then((response) => {
          const variationId = document
            .querySelector('.car-compare-' + index)
            .querySelector('.remove-car-button')
            .getAttribute('data-variation-id');
          if (variationId) {
            const firstCar = JSON.parse(
              localStorage.getItem('firstCarCompare'),
            );
            const secondCar = JSON.parse(
              localStorage.getItem('secondCarCompare'),
            );
            if (+variationId !== response.id) {
              submitForm();
            }
          }
        })
        .catch((e) => {
          console.error(e.message);
        });
    }

    function getVariations(car, idModel, idFuel) {
      const uri = '/api/content/most-economic/' + idModel + '/' + idFuel;
      callApi({
        uri: window.location.origin + sanitizeUri(uri),
        method: 'GET',
      })
        .then((response) => {
          let index;
          if (car.classList.contains('car-compare-1')) {
            index = 1;
          } else if (car.classList.contains('car-compare-2')) {
            index = 2;
          }
          if (index && response) {
            const customSelect = document
              .querySelector('.custom-select-car-' + index)
              .querySelector('.custom-select-variation');
            if (
              customSelect
                .querySelector('.select-items')
                .querySelectorAll('div').length === 0
            ) {
              response.forEach(function (model) {
                let option = document.createElement('option');
                option.setAttribute('value', model.id);
                option.textContent = model.variation_name;
                let div = document.createElement('div');
                div.setAttribute('data-value', model.id);
                div.setAttribute('data-variation-name', model.name);
                div.textContent = model.variation_name;
                let divPromoEconomic = document.createElement('div');
                divPromoEconomic.classList.add('promo-economic');
                if (model.onOffer) {
                  let offerSpan = document.createElement('span');
                  offerSpan.classList.add('promo-label');
                  offerSpan.innerHTML =
                    document.querySelector('#has-promo-badge').innerText;
                  divPromoEconomic.appendChild(offerSpan);
                } else if (model.mostEconomic) {
                  let mostEconomicSpan = document.createElement('span');
                  mostEconomicSpan.classList.add('mostEconomic-label');
                  mostEconomicSpan.innerHTML = document.querySelector(
                    '#most-economic-badge',
                  ).innerText;
                  divPromoEconomic.appendChild(mostEconomicSpan);
                }
                div.appendChild(divPromoEconomic);
                customSelect.querySelector('select').appendChild(option);
                customSelect.querySelector('.select-items').appendChild(div);
              });
            }
            customSelect
              .querySelectorAll('.select-items')
              .forEach(function (el) {
                if (el.querySelector('div')) {
                  el.querySelectorAll('div').forEach(function (el) {
                    el.addEventListener('click', function (e) {
                      onVariationClick(
                        e.currentTarget.getAttribute('data-variation-name'),
                        index,
                        +e.currentTarget.getAttribute('data-value'),
                      );
                    });
                  });
                }
              });
          }
        })
        .catch((e) => {
          console.error(e.message);
        });
    }

    function getFuels(car, idModel) {
      const uri = '/api/content/variation/' + idModel;
      callApi({
        uri: window.location.origin + sanitizeUri(uri),
        method: 'GET',
      })
        .then((response) => {
          let index;
          if (car.classList.contains('car-compare-1')) {
            index = 1;
          } else if (car.classList.contains('car-compare-2')) {
            index = 2;
          }
          if (index && response) {
            const customSelect = document
              .querySelector('.custom-select-car-' + index)
              .querySelector('.custom-select-fuel');
            if (customSelect) {
              if (
                customSelect
                  .querySelector('.select-items')
                  .querySelectorAll('div').length === 0
              ) {
                response.forEach(function (model) {
                  let option = document.createElement('option');
                  option.setAttribute('value', model.id);
                  option.innerText = model.name;
                  let div = document.createElement('div');
                  div.setAttribute('data-value', model.id);
                  div.innerText = model.name;
                  customSelect.querySelector('select').appendChild(option);
                  customSelect.querySelector('.select-items').appendChild(div);
                });
              }
            }
            customSelect
              .querySelectorAll('.select-items')
              .forEach(function (el) {
                if (el.querySelector('div')) {
                  el.querySelectorAll('div').forEach(function (el) {
                    el.addEventListener('click', function (e) {
                      getMostEconomicVariation(
                        idModel,
                        e.currentTarget.getAttribute('data-value'),
                        index,
                      );
                    });
                  });
                }
              });
            const fuel =
              customSelect.querySelector('.select-selected').innerText;
            response.forEach((f) => {
              if (fuel.toLowerCase() === f.name.toLowerCase()) {
                getVariations(car, idModel, f.id);
              }
            });
          }
        })
        .catch((e) => {
          console.error(e.message);
        });
    }

    function populateSelect() {
      const cars = document.querySelectorAll('.card-compare');
      cars.forEach((car) => {
        if (car.querySelector('.data-variation')) {
          const modelId = sanitizeGetAttribute(
            car.querySelector('.data-variation').getAttribute('data-model-id'),
          );

          if (modelId) {
            getFuels(car, modelId);
          }
        }
      });
    }

    function getVariationOptionals() {
      const id1 = document
        .querySelector('.item-accessories-list')
        .getAttribute('data-variation-id-1');
      const id2 = document
        .querySelector('.item-accessories-list')
        .getAttribute('data-variation-id-2');
      let uri = '';
      if (id1 && id2) {
        (uri =
          window.location.origin +
          '/api/getoptional/optional/' +
          id1 +
          '/' +
          id2),
          true;
      } else if (id1) {
        (uri = window.location.origin + '/api/getoptional/optional/' + id1),
          true;
      }
      if (uri) {
        callApi({ uri, method: 'GET' })
          .then((response) => {
            const { optional, sanguinetti = [] } = response;
            let savedOptionals = [];
            let clusters1, clusters2;
            if (Array.isArray(sanguinetti)) {
              clusters1 = sanguinetti;
              clusters2 = [];
            } else {
              clusters1 = Object.values(sanguinetti[id1]) || [];
              clusters2 = Object.values(sanguinetti[id2]) || [];
            }
            for (let el in optional) {
              if (optional.hasOwnProperty(el) && optional[el] && el !== 'nid') {
                if (!savedOptionals[el]) {
                  savedOptionals[el] = [];
                }

                savedOptionals[el] = optional[el];
                if (
                  !sanguinetti.length ||
                  clusters1.indexOf(el) > -1 ||
                  clusters2.indexOf(el) > -1
                ) {
                  savedOptionals[el]['show'] = true;
                }
              }
            }

            [id1, id2].forEach(function (id) {
              for (let el in savedOptionals) {
                let row;

                if (!document.querySelector('[data-optional="' + el + '"]')) {
                  row = document
                    .querySelector('.item-accessories-list .info-item-to-clone')
                    .cloneNode(true);
                  row.querySelector('.field').innerHTML = el;
                  row
                    .querySelector('.field')
                    .parentElement.setAttribute('data-optional', el);
                } else {
                  row = document.querySelector('[data-optional="' + el + '"]');
                }

                if (savedOptionals[el][id]) {
                  if (savedOptionals[el][id]['IDGruppo'] === '2') {
                    row.querySelector(
                      '[data-variation-id="' + id + '"',
                    ).innerHTML =
                      'Da ' + savedOptionals[el][id]['Prezzo'] + ' €';
                  } else if (
                    savedOptionals[el][id] === null ||
                    savedOptionals[el][id] === ''
                  ) {
                    row.querySelector(
                      '[data-variation-id="' + id + '"',
                    ).innerHTML = '-';
                  } else {
                    row.querySelector(
                      '[data-variation-id="' + id + '"',
                    ).innerHTML = 'Di serie';
                  }
                  row.classList.remove('hidden');
                  document
                    .querySelector('.item-accessories-list')
                    .appendChild(row);
                } else {
                  if (savedOptionals[el]['IDGruppo'] === '2') {
                    if (id) {
                      row.querySelector(
                        '[data-variation-id="' + id + '"',
                      ).innerHTML = 'Da ' + savedOptionals[el]['Prezzo'] + ' €';
                    }
                  } else if (
                    savedOptionals[el][id] === null ||
                    savedOptionals[el][id] === ''
                  ) {
                    row.querySelector(
                      '[data-variation-id="' + id + '"',
                    ).innerHTML = '-';
                  } else {
                    if (id) {
                      row.querySelector(
                        '[data-variation-id="' + id + '"',
                      ).innerHTML = 'Di serie';
                    }
                  }
                  if (
                    (savedOptionals[el][id1] && savedOptionals[el][id2]) ||
                    savedOptionals[el].show
                  ) {
                    row.classList.remove('hidden');
                    document
                      .querySelector('.item-accessories-list')
                      .appendChild(row);
                  }
                }
              }
            });
          })
          .catch((e) => console.error(e));
      }
    }

    function appendNewOptionalRow(optionals, el, index) {
      const clone = document
        .getElementsByClassName('info-item-to-clone')[0]
        .cloneNode(true);
      clone.setAttribute('data-optional-cluster', el);
      clone.getElementsByClassName('field')[0].innerHTML = el;
      if (optionals[el][index]['IDGruppo'] === '2') {
        clone.getElementsByClassName('value-car-' + index)[0].innerHTML =
          optionals[el][index]['Prezzo'] + ' €';
      } else {
        clone.getElementsByClassName('value-car-' + index)[0].innerHTML =
          'Di serie';
      }
      clone.classList.remove('hidden');
      document
        .getElementsByClassName('item-accessories-list')[0]
        .appendChild(clone);
    }

    // checkCarCompareRemove();
    cardAddToCompare();
    populateSelect();
    openModalFormLead();

    if (document.querySelector('.item-accessories-list')) {
      getVariationOptionals();
    }
  });
})();
